import {
  FormContextProvider,
  Input,
  InputField,
} from '@nbirl/nbi-common-ui-libs';
import { Form, FormikConfig } from 'formik';

import { createFolderValidationSchema } from './folder-name-form.form';
import { FolderNameFormValue } from './folder-name-form.model';

type FolderNameFormProps = {
  initialName?: string;
  inputLabel?: string;
  onSubmit: FormikConfig<FolderNameFormValue>['onSubmit'];
};

export const FolderNameForm: React.FC<FolderNameFormProps> = ({
  initialName,
  inputLabel,
  onSubmit,
  children,
}) => (
  <FormContextProvider<FolderNameFormValue>
    initialValues={{
      name: initialName || '',
    }}
    validateOnBlur={false}
    validationSchema={createFolderValidationSchema}
    onSubmit={onSubmit}
  >
    <Form>
      <InputField name="name" label={inputLabel} showRequiredIndicator={false}>
        {(field) => <Input type="name" {...field} />}
      </InputField>
      {children}
    </Form>
  </FormContextProvider>
);
